import React from 'react';
import { LucideIcon } from 'lucide-react';

interface SidebarItemProps {
  label: string;
  name?: string;
  icon: LucideIcon;
  active?: boolean;
  collapsed?: boolean;
  disabled?: boolean;
  visible?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const SidebarItem = ({
  label,
  name,
  icon: Icon,
  active = false,
  collapsed = false,
  disabled = false,
  visible,
  onClick,
}: SidebarItemProps) => {
  if (visible === false) {
    return null;
  }

  return (
    <button
      name={name}
      title={collapsed ? label : undefined}
      className={`
        sidebar-item 
        ${active ? 'sidebar-item-active' : ''}
        ${disabled ? 'sidebar-item-disabled' : ''}
      `}
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
    >
      <Icon size={22} className="sidebar-item-icon" />

      {!collapsed && <span className="sidebar-item-label">{label}</span>}
    </button>
  );
};

export default SidebarItem;
